import { render, staticRenderFns } from "./power.vue?vue&type=template&id=07d452c5"
import script from "./power.vue?vue&type=script&lang=js"
export * from "./power.vue?vue&type=script&lang=js"
import style0 from "./power.vue?vue&type=style&index=0&id=07d452c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports